export const API_SERVICIO_PAGOS = process.env.REACT_APP_API_SERVICIO_PAGOS;